import * as Sentry from '@sentry/vue';
import { useUserStore } from '@/store/user.ts';
import { storeToRefs } from 'pinia';

export const sentry = () => {
  const userStore = useUserStore();
  const { loginData } = storeToRefs(userStore);

  const configureScope = (
    type: string,
    scope: Sentry.Scope,
    addonValue?: string,
    addonKey?: string,
  ) => {
    scope.setUser({ email: loginData.value?.user?.email || 'not logged in' });
    scope.setExtra(addonKey || `place${type}`, addonValue || '');
  };

  return {
    sendError: (error: Error, addonValue?: string, addonKey?: string) => {
      Sentry.withScope((scope) => {
        configureScope('Error', scope, addonValue, addonKey);
      });
      Sentry.captureException(error);
    },
    sendWarning: (message: string, addonValue?: string, addonKey?: string) => {
      Sentry.withScope((scope) => {
        configureScope('Warning', scope, addonValue, addonKey);
      });
      Sentry.captureMessage(message, 'warning');
    },
    sendInfo: (message: string, addonValue?: string, addonKey?: string) => {
      Sentry.withScope((scope) => {
        configureScope('Info', scope, addonValue, addonKey);
      });
      Sentry.captureMessage(message, 'info');
    },
  };
};

// export const sentry = {
//   sendError: (error: Error, addonValue?: string, addonKey?: string) => {
//     Sentry.withScope((scope) => {
//       configureScope('Error', scope, addonValue, addonKey);
//     });
//     Sentry.captureException(error);
//   },
//   sendWarning: (message: string, addonValue?: string, addonKey?: string) => {
//     Sentry.withScope((scope) => {
//       configureScope('Warning', scope, addonValue, addonKey);
//     });
//     Sentry.captureMessage(message, 'warning');
//   },
//   sendInfo: (message: string, addonValue?: string, addonKey?: string) => {
//     Sentry.withScope((scope) => {
//       configureScope('Info', scope, addonValue, addonKey);
//     });
//     Sentry.captureMessage(message, 'info');
//   },
// };
